export enum DataType {
    Skills = 'skills',
    Cities = 'cities',
}
export enum RoleEnum {
  SALES_HEAD ='Sales Head',
  BSE='Sales Executive',
  BSM='Sales Manager',
}
